import CheckoutProductPreview from './CheckoutProductPreview'

export default CheckoutProductPreview
